import { useQuery } from '@tanstack/react-query'
import { EXPENSES } from '../../constants/endpoints'
import { getExpenses } from '../../utils/getExpenses'
import { useAuthStore } from '@/features/auth/store/authStore'

export const useExpensesQuery = ({ enabled }: { enabled: boolean }) => {
  const userId = useAuthStore((state) => state.user?._id)

  return useQuery({
    queryKey: [EXPENSES, userId],
    queryFn: getExpenses,
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
